import React from 'react';
import { observer } from 'mobx-react-lite';
import { DobCheckbox } from '@dedalusdiit/dob-components';
import { IWorklistSelectionHelper } from '@/Pages/GenericWorklist/Stores/WorklistSelectionHelper';
import Styles from '@/Pages/GenericWorklist/Components/DataGrid/WorklistDataGridConfig.module.scss';

interface SelectionHeaderCellProps {
    selectionStore: IWorklistSelectionHelper;
}

const SelectionHeaderCell: React.FC<SelectionHeaderCellProps> = observer(({ selectionStore }) => {
    return (
        <div className={Styles.selectionHeaderContainer}>
            <DobCheckbox checked={selectionStore.allSelected} />
            <span className={Styles.selectionHeaderCount}>{selectionStore.count}</span>
        </div>
    );
});

export default SelectionHeaderCell;
